__turbopack_context__.v({
  "info": "styles-module-scss-module__U_se4q__info",
});
